// import LogoShowcase from './Components/LogoShowcase/LogoShowcase';
import EnterpriseFeatures from './Components/EnterpriseFeatures/EnterpriseFeatures';
// import PlatformFeatures from './Components/PlatformFeatures/PlatformFeatures';
import IntegrationHero from './Components/Integrations/ExploreIntegrations';
import ReadyToTransformHero from './Components/ReadyToTransformEnterpriseTraning/ReadyToTransformHero';
import HeroSection from './Components/HeroSection/HeroSection';
import PopularIntegrations from './Components/PopularIntegrations/PopularIntegrations';
import PainPoints from './Components/PainPoints/PainPoints';
import WhatWeDo from './Components/WhatWeDo/WhatWeDo';
import WhoItsFor from './Components/WhoItsFor/WhoItsFor';
import HowItWorks from './Components/HowItWorks/HowItWorks';
import CtaBanner from './Components/CtaBanner/CtaBanner';
import PlatformCapabilities from './Components/PlatformCapabilities/PlatformCapabilities';
import BookDemo from './Components/BookDemo/BookDemo';

const LandingPage = () => {
  return (
    <div style={{background:"var(--color-card-bg)"}}>
    <HeroSection/>
    <IntegrationHero/>
    <EnterpriseFeatures/>
    <PlatformCapabilities/>
    <PopularIntegrations/>
    <PainPoints/>
    <WhatWeDo/>
    <WhoItsFor/>
    <HowItWorks/>
    <CtaBanner/>
    <BookDemo/>
    </div>
  );
};

export default LandingPage;